import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App'


//ReactDOM.render(elemento,contenedor);

//este contenedor sirve para indicar donde se almacenara la info o elementos

ReactDOM.render(<App/>,document.getElementById('app'));


